"use client";

import React from "react";
import "utils/i18n";

export default function I18nRegistry({
  children,
}: {
  children: React.ReactNode;
}) {
  return children;
}
